(function (angular) {
    'use strict';
    angular.module('app.sod', []);
})(angular);

